<script>
    export let name = '';
    export let size = 'normal';
    export let strokeWidth = '1';
    export let inline = false;
    export let left = false;

    let classNames = '';
    export {classNames as class};
</script>

<span class="app-icon size-{size} stroke-{strokeWidth} {classNames}" class:inline={ inline } class:left={ left }>
    <svg>
        {#if name}
            <use href="/app/assets/icons/{ name }.svg#{ name }"></use>
        {/if}
    </svg>
</span>

<style>
    .app-icon {
        display: block;
        line-height: 1;
        margin: auto;
    }

    .app-icon.inline {
        display: inline-block;
    }

    /*.app-icon img {*/
    /*    width: 100%;*/
    /*}*/

    .app-icon svg {
        display: block;
        width: 100%;
        height: 100%;
    }
    .app-icon.inline svg {
        display: inline-block;
    }

    .app-icon.stroke-1 svg {
        stroke-width: 1px;
    }
    .app-icon.stroke-2 svg {
        stroke-width: 2px;
    }
    .app-icon.stroke-5 svg {
        stroke-width: 5px;
    }

    .app-icon.left {
        margin-right: 5px;
    }

    .app-icon.size-10 {
        width: 10px;
        height: 10px;
    }

    .app-icon.size-12 {
        width: 12px;
        height: 12px;
    }

    .app-icon.size-normal, .app-icon.size-14 {
        width: 14px;
        height: 14px;
    }

    .app-icon.size-16 {
        width: 16px;
        height: 16px;
    }

    .app-icon.size-18 {
        width: 18px;
        height: 18px;
    }

    .app-icon.size-20 {
        width: 20px;
        height: 20px;
    }

    .app-icon.size-24 {
        width: 24px;
        height: 24px;
    }

    .app-icon.size-30 {
        width: 30px;
        height: 30px;
    }

    .app-icon.size-40 {
        width: 40px;
        height: 40px;
    }

    .app-icon.size-70 {
        width: 70px;
        height: 70px;
    }
</style>